const configService = {
  apiUrl: 'https://platzi-music-api.now.sh'
}

export default configService



// WEBPACK FOOTER //
// ./src/services/config.js